import { Stack } from '@hover/blueprint';
import { Button } from '@hover/blueprint/brand';
import { StyleProps } from '@chakra-ui/react';
import React from 'react';
import { Link } from 'gatsby';
import { ArrowButton } from '@hover/shared-components';

const wrapperStyle: StyleProps = {
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  mt: { base: 400, desktop: 500 },
};

const ButtonsGroup: React.FC = () => (
  <Stack
    spacing={{ base: 400, tablet: 600 }}
    direction={{ base: 'column', tablet: 'row' }}
    {...wrapperStyle}
  >
    <ArrowButton
      colorScheme="primary"
      variant="solid"
      to="/careers/"
      as={Link}
      w={{ base: '323px', tablet: 'auto' }}
    >
      Join Our Team
    </ArrowButton>
    <Button
      aria-label="Visit how it works page"
      as={Link}
      to="/how-it-works/"
      variant="outline"
      colorScheme="primary"
      px="400"
      w={{ base: '323px', tablet: 'auto' }}
    >
      Learn More
    </Button>
  </Stack>
);

export default ButtonsGroup;
